import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { fmtINR } from "../../lib/constants";
import { toast } from "sonner";
import { FloppyDisk, ArrowRight, Trash } from "@phosphor-icons/react";

export function SavedQuotes() {
  const [rows, setRows] = useState(null); // null = loading
  const [deleting, setDeleting] = useState(null);

  const load = () =>
    api.get("/booking/saved-quotes")
      .then((r) => setRows(r.data.saved_quotes || []))
      .catch(() => setRows([]));

  useEffect(() => { load(); }, []);

  const onDelete = async (id) => {
    if (!window.confirm("Delete this saved quote? This cannot be undone.")) return;
    setDeleting(id);
    try {
      await api.delete(`/booking/saved-quotes/${id}`);
      setRows((rs) => rs.filter((r) => r.saved_quote_id !== id));
      toast.success("Saved quote deleted");
    } catch (e) {
      toast.error(e.displayMessage || "Could not delete saved quote");
    } finally { setDeleting(null); }
  };

  if (rows === null || rows.length === 0) return null; // no noisy UI when empty

  const label = (r) => {
    const cf = r.inputs?.client_form || {};
    const from = cf.form?.pickup?.city || r.inputs?.pickup_address || "Pickup";
    const to = cf.form?.delivery?.city || r.inputs?.delivery_address || "Delivery";
    return `${from} → ${to}`;
  };

  return (
    <div className="mb-8" data-testid="saved-quotes-section">
      <div className="overline mb-2">SAVED QUOTES</div>
      <div className="grid-card">
        {rows.map((r) => (
          <div key={r.saved_quote_id}
               className="flex items-center justify-between px-4 py-3 border-b last:border-0 border-[hsl(var(--border))]"
               data-testid={`saved-quote-row-${r.saved_quote_id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-2 text-sm font-medium">
                <FloppyDisk size={14} weight="duotone" /> <span className="truncate">{label(r)}</span>
              </div>
              <div className="text-xs text-[hsl(var(--muted))] mt-0.5">
                Last quote {r.last_quote?.payable != null ? fmtINR(r.last_quote.payable) : "—"} · not yet accepted
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Link to={`/sender/new?resume=${r.saved_quote_id}`} className="btn-secondary text-xs"
                    data-testid={`resume-saved-quote-${r.saved_quote_id}`}>
                Resume <ArrowRight size={12} weight="bold" />
              </Link>
              <button onClick={() => onDelete(r.saved_quote_id)} disabled={deleting === r.saved_quote_id}
                      className="btn-ghost text-xs text-[hsl(var(--danger,0_70%_50%))]"
                      data-testid={`delete-saved-quote-${r.saved_quote_id}`}>
                <Trash size={12} weight="bold" /> {deleting === r.saved_quote_id ? "…" : "Delete"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
